var warn = require('../notices').warn

var populate = function (node, param, value, preventDispatch) {
  return fetch(("" + (node.getAttribute('formaction')) + param))
    .then(function (res) {
       // if session times out the response here is a autologin
       if (res.redirected) {
         location.reload();
         var defaultmsg = document.getElementById('defaultmessage').content
         throw new Error(defaultmsg);
      } else {
        return res.json()
      }
    })
    .then(
      function (json) { return (
        (node.disabled =
          json.length <= Number(node.dataset.emptyDisabled) || !json.length),
        json
      ); }
    )
    .then(function (json) {
      var ref = JSON.parse(node.dataset.datamap);
      var group = ref.group;
      var text = ref.text;
      var value = ref.value;
      var groups =
        group &&
        json
          .map(function (i) { return i[group]; })
          .filter(function (i, idx, arr) { return i && arr.indexOf(i) === idx; });
      groups && groups.length
        ? groups.map(function (label) {
            var optgroup = document.createElement('optgroup');
            optgroup.label = label;
            json
              .filter(function (i) { return i[group] === label; })
              .map(function (i) { return optgroup.appendChild(new Option(i[text], i[value])); });
            node.appendChild(optgroup);
          })
        : json.map(function (i) {
          return node.add(new Option(i[text], i[value]));
        });
      return node
    })
    .then(function (node) {
      value &&
        Array.from(node.options).map(
          function (i) { return (i.selected = new RegExp('\\b' + i.value + '\\b').test(value)); }
        );
      return node
    })
    .then(function(node) {
      !preventDispatch && dispatch(node)
    })
    .catch(warn);
};

// IE 11 Support
var getSelectedOptions = function (select) {
  return Array.from(select.options).filter(function(itm) {
    return itm.selected
  })
}

var selected = function (field) {
  if (field) {
    var selectedOptions = field.selectedOptions ? field.selectedOptions : getSelectedOptions(field)

    return Array.from(selectedOptions)
    .filter(function (i) { return i !== field.options[0]; })
    .map(function (i) { return i.value; })
    .toString();
  }
};

var dependentnode = function (node) {
  if(node && node.form){
    return node.form.elements.namedItem(node.dataset.dependentselect);
  }
};
var responsibleNode = function (node) {
  if(node && node.form){
    return node.form.querySelector('[data-dependentselect='+node.name+']');
  }
};

var reset = function (node) {
  node.options.length = node.dataset.placeholder ? Number(node.dataset.placeholder) : 1;
  node.disabled = true;
  Array.from(node.children)
    .filter(function (i) { return i.nodeName === 'OPTGROUP'; })
    .map(function (i) { return i.remove(); });
};

var opts = { bubbles: true, cancelable: true };

var valid = function (node) { return node.dispatchEvent(new Event('valid', opts)); };

var dispatch = function (node) { return (
  node.dispatchEvent(new Event('change', opts)),
  requestAnimationFrame(function () { return valid(node); })
); };

var onchangeHandler = function (e) {
  var field = e.target || e;
  var node = dependentnode(field);
  if (node) {
    var param = selected(field);
    var value = selected(node);
    reset(node);
    onchangeHandler(node);
    param ? populate(node, param, value) : dispatch(node);
  }
};

window.addEventListener('change', onchangeHandler, true);

var storageSetSelect = function(el, data) {
  if (el && el.dataset && el.dataset.dependentselect && el.dataset.datamap) {
    // A populated dependent selector
    // Start the process of loading
    reset(el)
    populate(el, data.responsible, data.value, true)
  }
}

var storageGetSelect = function(el) {
  var responsible = responsibleNode(el)
  return {responsible: (responsible ? responsible.options[responsible.selectedIndex].value : null), value: selected(el)}
}

exports.storageSetSelect = storageSetSelect
exports.storageGetSelect = storageGetSelect

var noSessionStorage = function (ev) {
  var target = ev.target
  if (!target.dataset.datamap) {
    // Can only update the responsible select not ones which are both
    // Get the current value
    var selectedOption = target.options[target.selectedIndex]

    // Is the value different to what the server sent?
    if (!selectedOption.hasAttribute('selected')) {
      // Different - invoke
      dispatch(target)
    }
  }
}

window.addEventListener('cm-no-session-storage', noSessionStorage, true)
